/**
 * Program Monthly Counts Controller
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('ProgramMonthlyCountsController', [
    '$scope',
    'ProgramMonthlyCounts',
    function($scope, ProgramMonthlyCounts){

    /**
     * Loading state
     *
     * @type {Boolean}
     */
    $scope.loading = true;

    /**
     * Define starting data
     *
     * @type {Object}
     */
    $scope.data = {
        headers: [],
        groups:[],
        programs:[],
    }

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        this.load({
            brand: brand || $scope.$parent.brand,
            from : from || $scope.$parent.from,
            to   : to || $scope.$parent.to,
        });
    }

    /**
     * Load the data
     *
     * @param  {object} query
     * @return void
     */
    $scope.load = function(query) {
        /* Enable loader */
        $scope.loading = true;
        /* fetch data */
        ProgramMonthlyCounts
            .get(query)
            .$promise
            .then(function(response, headers){
                /* Replace the data*/
                $scope.data = response.data;
                /* Disable loader */
                $scope.loading = false;
            }, function(response, headers){
                _.each(response.data, function(error){
                    $.publish('resource.error', error);
                });
            });
    }

    /**
     * Complet the counts
     *
     * @param  string | array   field
     * @param  string           header
     * @param  string | null    group
     * @return int
     */
    $scope.headcount = function(field, header, group = null, count = 0) {

        _.castArray(field).forEach(field => {
            count += _.sumBy(this.programs(header, group), field);
        });

        return count;
    }

    /**
     * Access programs as method
     *
     * @param  string           header
     * @param  string | null    group
     * @return collection
     */
    $scope.programs = function(header, group = null) {
        /* Chain the values */
        return _.chain(this.data.programs)
                /* filter by header value, must be exact match */
                .filter({header:header})
                /* filter by group value, must be exact match */
                .filter((program)=>{
                    return _.isNull(group) || _.isEqual(program.month, group);
                })
                .value();
    }
}]);
